import React from "react";

const tableHeaders = [
  { title: "Sr.", width: "5%", align: "center" },
  { title: "Item Description", width: "35%", align: "left", required: true },
  { title: "Weight", width: "14%", align: "left", required: true },
  { title: "Unit", width: "10%", align: "left", required: true },
  { title: "Pcs", width: "10%", align: "left" },
  { title: "Rate (₹)", width: "12%", align: "left", required: true },
  { title: "Amount (₹)", width: "14%", align: "left" },
  { title: "Action", width: "6%", align: "center" },
];

const PoItems = ({
  items = [],
  itemErrors = [],
  handleItemChange,
  handleAddItem,
  handleRemoveItem,
  canAddMoreItems = false,
  totalWeight = 0,
  subtotal = 0,
  isLoading = false,
  error = {},
}) => {
  return (
    <>
      <div className="row mt-4">
        <div className="col-12">
          <div className="form-heading d-flex justify-content-between align-items-center mb-3">
            <div>
              <h4 className="mb-0">Items Details</h4>
            </div>
            <button
              type="button"
              className="btn add-pluss"
              style={{
                backgroundColor: "var(--primary-clr)",
                color: "white",
              }}
              onClick={handleAddItem}
              disabled={!canAddMoreItems || isLoading}
              title={
                !canAddMoreItems
                  ? "Complete current item details to add more"
                  : "Add new item"
              }
            >
              <i className="fa fa-plus me-1"></i> Add Item
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table
              className="table table-bordered table-hover"
              style={{ minWidth: "850px" }}
            >
              <thead className="table-light">
                <tr>
                  {tableHeaders.map((header, index) => (
                    <th
                      key={index}
                      style={{ width: header.width, verticalAlign: "middle" }}
                      className={header.align === "center" ? "text-center" : ""}
                    >
                      {header.title}{" "}
                      {header.required && <span className="text-danger">*</span>}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center align-middle">
                      <strong>{index + 1}</strong>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${itemErrors[index]?.item_description ? "is-invalid" : ""
                          }`}
                        value={item.item_description || ""}
                        onChange={(e) =>
                          handleItemChange(index, "item_description", e.target.value)
                        }
                        placeholder="e.g. Enter Item name"
                      />
                      {itemErrors[index]?.item_description && (
                        <small className="text-danger">
                          {itemErrors[index].item_description}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        className={`form-control form-control-sm text-end ${itemErrors[index]?.weight ? "is-invalid" : ""
                          }`}
                        value={item.weight}
                        onChange={(e) =>
                          handleItemChange(index, "weight", e.target.value)
                        }
                        placeholder="0.00"
                      />
                      {itemErrors[index]?.weight && (
                        <small className="text-danger">
                          {itemErrors[index].weight}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${itemErrors[index]?.unit ? "is-invalid" : ""
                          }`}
                        value={item.unit || ""}
                        onChange={(e) =>
                          handleItemChange(index, "unit", e.target.value)
                        }
                        placeholder="e.g. KGS"
                      />
                      {itemErrors[index]?.unit && (
                        <small className="text-danger">
                          {itemErrors[index].unit}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={item.pcs}
                        onChange={(e) =>
                          handleItemChange(index, "pcs", e.target.value)
                        }
                        placeholder="0"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        className={`form-control form-control-sm text-end ${itemErrors[index]?.rate ? "is-invalid" : ""
                          }`}
                        value={item.rate}
                        onChange={(e) =>
                          handleItemChange(index, "rate", e.target.value)
                        }
                        placeholder="0.00"
                      />
                      {itemErrors[index]?.rate && (
                        <small className="text-danger">
                          {itemErrors[index].rate}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm text-end bg-light fw-semibold"
                        value={`${Number(item.amount || 0).toFixed(2)}`}
                        disabled
                        readOnly
                        placeholder="₹ 0.00"
                        title="Amount is calculated automatically"
                      />
                    </td>
                    <td className="text-center align-middle">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleRemoveItem(index)}
                        disabled={items.length === 1 || isLoading}
                        title="Delete Item"
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}

                {/* Total Summary Row: Only show Total Weight and Subtotal Amount */}
                <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "600" }}>
                  <td className="text-center align-middle">TOTAL</td>
                  <td></td>
                  <td className="text-end align-middle">
                    {Number(totalWeight || 0).toFixed(2)}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end align-middle">
                    ₹ {Number(subtotal || 0).toFixed(2)}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            {error.items && (
              <div className="alert alert-danger mt-2 py-2">
                <i className="fa fa-exclamation-circle me-2"></i>
                {error.items}
              </div>
            )}

            {!canAddMoreItems && items.length > 0 && (
              <div
                className="alert mt-2 py-2"
                style={{
                  backgroundColor: "rgba(255, 105, 35, 0.1)",
                  border: "1px solid var(--primary-clr)",
                  color: "var(--primary-clr)",
                  fontSize: "12px",
                }}
              >
                <i className="fa fa-info-circle me-2"></i>
                Complete current item details (Description, Unit, Weight or Pcs, Rate) to add more items
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PoItems;
